module.exports = __webpack_public_path__ + "media/assets/images/flags/ws-d3d33d46cce156adc37c61e136950ec4.svg";